
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from './login';
import Tasks from './tasks';
import Users from './users';
import Statuses from './statuses';
import Reports from './reports';


import PageNotFound from './pageNotFound';



function App() {
  return   <BrowserRouter>
    <Routes>
      <Route path="login" element={<Login />} />
      <Route index element={<Reports />} />
      <Route path="reports" element={<Reports />} />
      <Route path="statuses" element={<Statuses />} />
      <Route path="tasks" element={<Tasks />} />
      <Route path="users" element={<Users />} />
      <Route path="login" element={<Login />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  </BrowserRouter>
}

export default App;
